import { useState } from "react";
import InputField from "../../../DesignSystem/Inputs/InputField";
import DateField from "../../../DesignSystem/Inputs/DateField";
import TextArea from "../../../DesignSystem/Inputs/TextArea";
import CustomSelect from "../../../DesignSystem/Dropdowns/CustomSelect";
import { ReactComponent as DesignIcon } from "../../../../assets/icons/marketingDashbaord/Design.svg";
import { ReactComponent as HostingIcon } from "../../../../assets/icons/paraplanningDashboard/Logs.svg";
import {
  calculateAmountToCharge,
  DOMAIN_REGISTRATION_TYPES,
} from "../websiteConstants";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as DropdownIcon } from "../../../../assets/icons/paraplanningDashboard/ArrowDropdown.svg";

const WebsiteDetailsSections = ({ formData, setFormData, readOnly = false, validationErrors = {} }) => {
  const [collapsedDomains, setCollapsedDomains] = useState({});
  const isLive = String(formData.status || "").trim().toLowerCase() === "live";

  const updateDomain = (index, field, value) => {
    setFormData((current) => ({
      ...current,
      domains: current.domains.map((domain, domainIndex) =>
        domainIndex === index ? { ...domain, [field]: value } : domain,
      ),
    }));
  };

  const deleteDomain = (index) => {
    setFormData((current) => ({
      ...current,
      domains: current.domains.filter((_, domainIndex) => domainIndex !== index),
    }));
    setCollapsedDomains({});
  };

  const toggleDomain = (index) => {
    setCollapsedDomains((current) => ({
      ...current,
      [index]: !current[index],
    }));
  };

  const updateDomainSection = (index, section, field, value) => {
    setFormData((current) => ({
      ...current,
      domains: current.domains.map((domain, domainIndex) =>
        domainIndex === index
          ? {
              ...domain,
              [section]: { ...domain[section], [field]: value },
            }
          : domain,
      ),
    }));
  };

  return (
    <section className="website-details-sections">
      {formData.domains.map((domain, index) => (
        <div className="website-domain-layout" key={`domain-${index}`}>
          <div className="website-domain__header row-space-between">
            <h4 className="FP_Content_Semibold text-black">
              {String(domain.domainName || "").trim() || `Domain ${index + 1}`}
            </h4>
            <div className="row align-center gap-s">
              {!readOnly && (
                <button
                  type="button"
                  className="website-domain-delete website-domain-delete--label FP_Content"
                  onClick={() => deleteDomain(index)}
                  aria-label={`Delete domain ${index + 1}`}
                >
                  <DeleteIcon aria-hidden />
                  Delete domain
                </button>
              )}
              <button
                type="button"
                className="website-domain__toggle"
                onClick={() => toggleDomain(index)}
                aria-label={`${collapsedDomains[index] ? "Expand" : "Collapse"} domain ${index + 1}`}
                aria-expanded={!collapsedDomains[index]}
              >
                <DropdownIcon className={collapsedDomains[index] ? "website-chevron" : "website-chevron website-chevron--open"} />
              </button>
            </div>
          </div>
          {(!collapsedDomains[index] || Object.keys(validationErrors).some((field) => field.startsWith(`domains.${index}.`))) && <div className="fit-column gap-l">
            <div className="website-detail-container">
              {/* <div className="website-section-heading FP_Help_Text_Semibold">Domain</div> */}
            <div className="website-fields website-fields--three">
              <InputField label="Domain Name" value={domain.domainName} disabled={readOnly}
                onChange={(e) => updateDomain(index, "domainName", e.target.value)} />
              <DateField label="Date Paid" value={domain.datePaid} disabled={readOnly}
                onChange={(e) => updateDomain(index, "datePaid", e.target.value)} />
              <InputField label="Paid By" value={domain.paidBy} disabled={readOnly}
                onChange={(e) => updateDomain(index, "paidBy", e.target.value)} />
              <CustomSelect
                label="Registration or Transfer"
                options={DOMAIN_REGISTRATION_TYPES}
                value={domain.registrationType}
                disabled={readOnly}
                searchable={false}
                placeholder="Select registration or transfer"
                onChange={(e) => updateDomain(index, "registrationType", e.target.value)}
              />
              <InputField label="No of Years" type="number" min="0" step="1" inputMode="numeric"
                error={Boolean(validationErrors[`domains.${index}.numberOfYears`])} value={domain.numberOfYears} disabled={readOnly}
                onChange={(e) => updateDomain(index, "numberOfYears", e.target.value)} />
              <InputField label="Registrar" value={domain.registrar} disabled={readOnly}
                onChange={(e) => updateDomain(index, "registrar", e.target.value)} />
              <InputField label="Amount Paid (£)" type="number" min="0" step="0.01" inputMode="decimal"
                error={Boolean(validationErrors[`domains.${index}.amountPaid`])} value={domain.amountPaid} disabled={readOnly}
                onChange={(e) => updateDomain(index, "amountPaid", e.target.value)} />
              <InputField label="Markup (%)" type="number" min="0" step="0.01" inputMode="decimal"
                error={Boolean(validationErrors[`domains.${index}.markup`])} value={domain.markup} disabled={readOnly}
                onChange={(e) => updateDomain(index, "markup", e.target.value)} />
              <InputField label="Amount To Charge (£)" type="number" min="0" step="0.01" inputMode="decimal"
                value={calculateAmountToCharge(domain.amountPaid, domain.markup)} readOnly />
              <div className="website-span-three">
                <TextArea label="Notes" rows={3} value={domain.notes} disabled={readOnly}
                  placeholder="Additional domain notes"
                  onChange={(e) => updateDomain(index, "notes", e.target.value)} />
              </div>
            </div>
            </div>

            <div className="website-detail-container fit-column gap-m">
              <div className="website-section-heading website-section-heading__label row align-center text-align-left gap-s FP_Help_Text_Semibold"><DesignIcon /> Design Details</div>
              <div className="website-fields website-fields--three website-subsection">
                <DateField label="Live Date" required={isLive} error={Boolean(validationErrors[`domains.${index}.design.liveDate`])} value={domain.design?.liveDate || ""} disabled={readOnly}
                  onChange={(e) => updateDomainSection(index, "design", "liveDate", e.target.value)} />
                <InputField label="Amount To Charge (£)" required={isLive} type="number" min="0" step="0.01" inputMode="decimal"
                  error={Boolean(validationErrors[`domains.${index}.design.amountToCharge`])} value={domain.design?.amountToCharge || ""} disabled={readOnly}
                  onChange={(e) => updateDomainSection(index, "design", "amountToCharge", e.target.value)} />
                <InputField label="Charge Across (No of Months)" required={isLive} type="number" min="0" step="1" inputMode="numeric"
                  error={Boolean(validationErrors[`domains.${index}.design.chargeAcross`])} placeholder="Spread Payment Across" value={domain.design?.chargeAcross || ""} disabled={readOnly}
                  onChange={(e) => updateDomainSection(index, "design", "chargeAcross", e.target.value)} />
              </div>
            </div>

            <div className="website-detail-container fit-column gap-m">
              <div className="website-section-heading website-section-heading__label row align-center text-align-left gap-s FP_Help_Text_Semibold"><HostingIcon /> Hosting Details</div>
              <div className="website-fields website-fields--three website-subsection">
                <InputField label="Monthly Charge (£)" required={isLive} type="number" min="0" step="0.01" inputMode="decimal"
                  error={Boolean(validationErrors[`domains.${index}.hosting.monthlyCharge`])} value={domain.hosting?.monthlyCharge || ""} disabled={readOnly}
                  onChange={(e) => updateDomainSection(index, "hosting", "monthlyCharge", e.target.value)} />
              </div>
            </div>
          </div>}
        </div>
      ))}

      {!formData.domains.length && (
        <p className="FP_Content primary">No domains added.</p>
      )}

    </section>
  );
};

export default WebsiteDetailsSections;
